import script from "./batch-received-by-philpost.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-received-by-philpost.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__